import { AIFunction } from '@/utils/const';

export const getBasePromptConfig = (source: AIFunction) => ({
  type: 'prompt',
  label: 'Prompt',
  key: 'prompt',
  config: {
    maxLength: 2000,
    trackSource: source, // 声明式埋点
  },
});
